.aside > * {
    border-left: solid 4px var(--off-white-dk);
    padding-left: 12px;
}
